var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.434,
    height: 25.38,
    viewBox: "0 0 37.434 25.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31884",
    x: 0,
    y: 0,
    width: 37.434,
    height: 25.38,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BE-Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31884)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31884-2",
    "data-name": "Rectangle 31884",
    width: 34.434,
    height: 22.38,
    transform: "translate(1.5 0.5)",
    fill: "#f02d3c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31885",
    "data-name": "Rectangle 31885",
    width: 12.163,
    height: 22.38,
    transform: "translate(11.636 0)",
    fill: "#fadc46"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31886",
    "data-name": "Rectangle 31886",
    width: 11.635,
    height: 22.38,
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeFlag);
export default __webpack_public_path__ + "static/media/BE-Flag.5e14f0f0b52b9cf6081d0c6ca5def232.svg";
export { ForwardRef as ReactComponent };